const langDrawer = document.querySelector('[data-name="lang-curr-drawer"]');
const langBtnSwitcher = document.querySelector('[data-name="lang-mobile-switch"]');

function openLangDrawer() {
  setTimeout(() => {
    langDrawer.classList.add("active");
  });
  document.body.classList.add('overflow-hidden');
}

function closeLangDrawer() {
  langDrawer.classList.remove("active");
  document.body.classList.remove('overflow-hidden');
}

function toggleLangDrawer() {
  if (langDrawer.classList.contains("active")) {
    closeLangDrawer();
  } else {
    openLangDrawer();
  }
}

function hideDrawer(e) {
  if (e.target === langDrawer) {
    closeLangDrawer();
  }
}

document.querySelector('[data-name="lang-btn-toggle"]').addEventListener("click", toggleLangDrawer);
langDrawer.addEventListener("click", hideDrawer);

function changeCurrentLangAndCurrInSidebar() {
  if (document.URL.indexOf("/de") > -1) {
    langBtnSwitcher.innerHTML = "DE";
  } else if (document.URL.indexOf("/pl") > -1) {
    langBtnSwitcher.innerHTML = "PL";
  } else if (document.URL.indexOf("/fr") > -1) {
    langBtnSwitcher.innerHTML = "FR";
  } else if (document.URL.indexOf("/it") > -1) {
    langBtnSwitcher.innerHTML = "IT";
  } else if (document.URL.indexOf("/es") > -1) {
    langBtnSwitcher.innerHTML = "ES";
  } else if (document.URL.indexOf("/nl") > -1) {
    langBtnSwitcher.innerHTML = "NL";
  } else if (document.URL.indexOf("/sv") > -1) {
    langBtnSwitcher.innerHTML = "SV";
  } else {
    langBtnSwitcher.innerHTML = "EN";
  }
}
// changeCurrentLangAndCurrInSidebar();